import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import {
  entityPathMappings,
  INavigatePossibleActions,
  RydeAppUnit,
  usePrefixedRouting,
} from "@ryde/shared";

/* this hook is not intended for direct use, use useCrudNavigate instead */

export const useCrudRoutes = () => {
  const { navigatePrefixed, addPrefix } = usePrefixedRouting();
  const location = useLocation();
  const locationSearch = useMemo(
    () => location.search || "",
    [location.search],
  );
  const crudRoutes: Record<RydeAppUnit, INavigatePossibleActions> =
    useMemo(() => {
      const routes = {} as Record<RydeAppUnit, INavigatePossibleActions>;
      Object.entries(entityPathMappings).forEach(([key, path]) => {
        if (!key) {
          return;
        }

        routes[key as RydeAppUnit] = {
          list: (keepQuery = true) => {
            navigatePrefixed(`/${path}${keepQuery ? locationSearch : ""}`);
          },
          listUrl: addPrefix(`/${path}`),
          new: (keepQuery = true) => {
            navigatePrefixed(`/${path}/new${keepQuery ? locationSearch : ""}`);
          },
          edit: (id: number, keepQuery = true): void => {
            navigatePrefixed(
              `/${path}/edit/${id}${keepQuery ? locationSearch : ""}`,
            );
          },
          add: (duplicateFromId?: number, keepQuery = true) => {
            if (duplicateFromId) {
              navigatePrefixed(
                `/${path}/add/${duplicateFromId}${keepQuery ? locationSearch : ""}`,
              );
            } else {
              navigatePrefixed(
                `/${path}/add${keepQuery ? locationSearch : ""}`,
              );
            }
          },
        };
      });
      return routes;
    }, [addPrefix, locationSearch, navigatePrefixed]);

  return crudRoutes;
};
